import { render, staticRenderFns } from "./HomeEn.vue?vue&type=template&id=36c3a53a&"
import script from "./HomeEn.vue?vue&type=script&lang=js&"
export * from "./HomeEn.vue?vue&type=script&lang=js&"
import style0 from "./HomeEn.vue?vue&type=style&index=0&id=36c3a53a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports